<template>
  <div class="notification-stripe__message dea-bg-white dea-border-grey-light" :class="setPositions">
    <div class="notification-stripe__message-icon dea-border-grey-light">
      <img :src="icon" :alt="message.icon" />
    </div>
    <div class="notification-stripe__message-description dea-heading--regular-xxs" @click="openUrl(message.url)">
      {{ message.intro }} {{ message.description }} {{ showCta(message.url) ? message.cta : "" }} {{ idsList }}
    </div>
    <div
      class="notification-stripe__message-button-container dea-border-grey-light"
      @click="$emit('message-close', message.ids)"
    >
      <i class="dea-ico-close dea-font-grey-medium-light"></i>
    </div>
  </div>
</template>

<script>
import alertIcon from "@/assets/icons/messages/AP_ico_alert.png";
import infoIcon from "@/assets/icons/messages/AP_ico_info.png";
import questionIcon from "@/assets/icons/messages/AP_ico_question.png";

export default {
  name: "NotificationStripe",
  props: {
    debug: {
      type: Boolean,
      default: false,
    },
    message: {
      type: Object,
      required: true,
    },
    positions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      alertIcon,
      infoIcon,
      questionIcon,
    };
  },
  computed: {
    icon() {
      if (this.message.icon === "alert") {
        return this.alertIcon;
      }
      if (this.message.icon === "info") {
        return this.infoIcon;
      }
      return this.questionIcon;
    },
    idsList() {
      return this.debug && this.message.ids.length ? `[ID: ${this.message.ids.join(", ")}]` : "";
    },
    setPositions() {
      return this.positions.map(position => `notification-stripe__message--${position}`);
    },
  },
  methods: {
    openUrl(url) {
      if (this.$route && this.$route.path === url) {
        return;
      }
      if (url.indexOf("/") === 0) {
        this.$router.push({ path: url });
      } else {
        window.open(url, "_blank");
      }
    },
    showCta(url) {
      if (this.$route && this.$route.path === url) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils"; //sass-lint:disable-line clean-import-paths

.notification-stripe__message {
  align-items: center;
  border: $border-light;
  display: flex;
  flex-direction: row;
  padding: $space-xm-small 0;

  &-icon {
    border-right: $border-bold;
    display: flex;
    padding: 0 $space-m-small;
  }

  &-description {
    cursor: pointer;
    flex-grow: 2;
    margin: 0 $space-xm-small;
  }

  &-button-container {
    border-left: $border-bold;
    cursor: pointer;
    line-height: $space-xm-small;
    padding: $space-xs-small $space-xm-small;
  }

  &--first {
    border-top-left-radius: $border-radius-large;
    border-top-right-radius: $border-radius-large;
  }

  &--last {
    border-bottom-left-radius: $border-radius-large;
    border-bottom-right-radius: $border-radius-large;
  }
}
</style>
